<div class="footer-main text">
  <image-loader-utils url="18" extraClasses="svg-18"></image-loader-utils>
  <div class="footer-up">
    <div class="footer-wrap">
      <div class="footer-box">
        <div class="title">{{ 'hightligths' | t }}</div>
        <div class="item" *ngFor="let league of leagueData" (click)="getMatch(league)">
          {{ league.TournamentText }}
        </div>
      </div>

      <div class="footer-box no-space">
        <div class="title">{{ 'offer' | t }}</div>
        <a class="item" [routerLink]="['/sports']">{{ 'b3000_sports' | t }}</a>
        <a class="item" [routerLink]="['/live']">{{ 'b3000_live' | t }}</a>
      </div>
      <div class="footer-box">
        <div class="title">{{ 'footer_information' | t }}</div>
        <ng-container *ngFor="let item of this.footerInformationData">
          <ng-container *ngIf="item.route">
            <a class="item" [routerLink]="item.route" [target]="item.target">{{ item.text }}</a>
          </ng-container>
          <ng-container *ngIf="item.link">
            <a class="item" [href]="item.link" [target]="item.target">{{ item.text }}</a>
          </ng-container>
        </ng-container>
      </div>
      <div class="footer-box">
        <div class="title">{{ 'company' | t }}</div>
        <a class="item" routerLink="/article/{{ 'route_article_footer_7' | t }}">{{ 'AboutUs' | t }}</a>
        <a class="item" routerLink="/article/{{ 'route_article_footer_8' | t }}">{{ 'footer_imprint' | t }}</a>
        <ng-container [ngSwitch]="['wettarena'] | getProductName">
          <ng-container *ngSwitchCase="'wettarena'">
            <a class="item" href="https://wettarena-shop.com/">{{ 'franchise' | t }} </a>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
      <ng-container *ngSwitchCase="'wettarena'">
        <div class="social-account">
          <a href="https://instagram.com/wettarena?igshid=YmMyMTA2M2Y=" target="_blank">
            <image-loader-utils url="instagram" extraClasses="instagram-icon"></image-loader-utils>
          </a>
          <a href="https://www.facebook.com/WettarenaSportwetten/" target="_blank">
            <image-loader-utils url="facebook" extraClasses="facebook-icon"></image-loader-utils>
          </a>
        </div>
        <a class="up-text" href="https://www.bzga.de/" target="_blank">{{ 'footer_text_1' | t }}</a>
        <div class="footer-divider">
          <!--<div class="divider-logo"></div>-->
        </div>
        <div class="info-contain">
          <span>
            {{ 'footer_text_13' | t }}<a href="https://www.wettarena.de">{{ 'footer_text_14' | t }}</a> {{ 'footer_text_15' | t }}
            <a href="https://rp-darmstadt.hessen.de/">{{ 'footer_text_16' | t }}</a> {{ 'footer_text_17' | t }} {{ 'footer_text_18' | t }}
            <a href="https://www.gluecksspiel-behoerde.de/de/">{{ 'footer_text_19' | t }} </a> {{ 'footer_text_20' | t }}
          </span>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <div class="social-account">
          <image-loader-utils url="twitter" extraClasses="twitter-icon"></image-loader-utils>
          <image-loader-utils url="instagram" extraClasses="instagram-icon"></image-loader-utils>
          <image-loader-utils url="facebook" extraClasses="facebook-icon"></image-loader-utils>
        </div>
        <div class="up-text">{{ 'footer_text_1' | t }}</div>
        <div class="footer-divider">
          <!--<div class="divider-logo"></div>-->
        </div>
        <div class="info-contain">{{ 'footer_text_2' | t }}</div>
      </ng-container>
    </ng-container>
  </div>
  <p class="versionText">
    <code>v.{{ VERSION_TEXT }}</code>
  </p>
  <div class="footer-down">
    <ng-container [ngSwitch]="['b3000'] | getProductName">
      <ng-container *ngSwitchCase="'b3000'">
        <div class="partner-name">
          <div class="down-text">{{ 'Footer_Partner_Text' | t }}</div>
          <image-loader-utils url="1860-logo" extraClasses="logo-partner" [shared]="false" imageFormat="png"></image-loader-utils>
          <image-loader-utils url="eintracht_Braunschweig" extraClasses="logo-partner-b3000" [shared]="false" imageFormat="png"></image-loader-utils>
        </div>
        <div class="more-from">{{ 'more_from_the_game' | t }}</div>
      </ng-container>
    </ng-container>
  </div>
</div>
<div class="footer-mobile-main text">
  <div class="footer-up">
    <div class="top-button-container" (click)="this._UiHelper.ScrollToTop()">
      <div class="top-button">
        <div class="text-name">
          {{ 'back_to_top' | t }}
        </div>
        <div class="right">
          <image-loader-utils url="up-arrow" extraClasses="arrow-icon up"></image-loader-utils>
        </div>
      </div>
    </div>

    <div class="language-menu">
      <div class="selected-language" (click)="toggleLanguageMenu()">
        <div class="selected-flag">
          <image-loader-utils [url]="_LocalizationService.ISOABBR" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
        </div>
        <div class="selected-lang-name">
          {{ _LocalizationService.langDatas[_LocalizationService.LANGCODE]?.langNativeNames }}
        </div>
        <div class="right">
          <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (isOpenLangMenu ? 'up' : 'down')"></image-loader-utils>
        </div>
      </div>
      <ng-container *ngFor="let lang of langDatasArry">
        <div class="lang-dropdown-menu" *ngIf="isOpenLangMenu">
          <div class="lang-dropdown-item" (click)="selectionChange(lang.langCode)">
            <div class="flag">
              <image-loader-utils [url]="lang.ISOabbr" [isFlags]="true" extraClasses="flag-rounded"></image-loader-utils>
            </div>
            <div class="lang">
              {{ lang.langNativeNames }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="info-click text">
      <ng-container *ngFor="let item of this.footerInformationData">
        <ng-container *ngIf="item.route">
          <a class="info-item" [routerLink]="item.route" [target]="item.target">{{ item.text }}</a>
        </ng-container>
        <ng-container *ngIf="item.link">
          <a class="info-item" [href]="item.link" [target]="item.target">{{ item.text }}</a>
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let item of this.footerCompanyData">
        <ng-container *ngIf="item.route">
          <a class="info-item" [routerLink]="item.route" [target]="item.target">{{ item.text }}</a>
        </ng-container>
        <ng-container *ngIf="item.link">
          <a class="info-item" [href]="item.link" [target]="item.target">{{ item.text }}</a>
        </ng-container>
      </ng-container>
    </div>
    <div class="footer-text-container">
      <ng-container [ngSwitch]="['wettarena'] | getProductName">
        <ng-container *ngSwitchCase="'wettarena'">
          <div class="footer-text-item" style="padding: 10px">
            <span>
              {{ 'footer_text_13' | t }}<a href="https://www.wettarena.de">{{ 'footer_text_14' | t }}</a> {{ 'footer_text_15' | t }}
              <a href="https://rp-darmstadt.hessen.de/">{{ 'footer_text_16' | t }}</a> {{ 'footer_text_17' | t }} {{ 'footer_text_18' | t }}
              <a href="https://www.gluecksspiel-behoerde.de/de/">{{ 'footer_text_19' | t }} </a> {{ 'footer_text_20' | t }}
            </span>
          </div>
          <div class="footer-text-item">
            <a class="item" href="{{ 'healthUrl' | getEnv }}" target="_blank"> {{ 'footer_text_10' | t }} </a>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="footer-text-item">
            {{ 'footer_text_9' | t }}
          </div>
          <div class="footer-text-item">
            <a class="item" routerLink="/article/{{ 'route_article_footer_1' | t }}"> {{ 'footer_text_10' | t }} </a>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="mobile-lock-button-main-container text" *ngIf="this._UserHelper.isSignedIn">
      <div class="mobile-lock-button">
        <div class="mobile-lock-item">
          <div class="mobile-lock-text">
            {{ 'b3000_current_slip_core_text_3' | t }}
          </div>
          <div id="accountLockButton24" mat-flat-button class="mobile-lock-button">
            {{ '24h_Lock' | t }}
          </div>
        </div>

        <section class="account-lock-section" *ngIf="progressValue > 0">
          <ng-container *ngIf="holdSeconds != 0">
            <mat-progress-bar class="account-lock-progress-bar" mode="determinate" value="{{ this.progressValue }}"></mat-progress-bar>
            <div class="progress-bar-text">
              {{ holdSeconds }}
            </div>
          </ng-container>
        </section>
      </div>
    </div>
  </div>
  <div class="info-text-container">
    <ng-container [ngSwitch]="['b3000'] | getProductName">
      <ng-container *ngSwitchCase="'b3000'">
        <div class="footer-info-text-row">{{ footerText.addressText | t }}</div>
        <div class="info-text-header">{{ footerText.addressTextHeader | t }}</div>
      </ng-container>
    </ng-container>
    <div class="divider-mobil">
      <image-loader-utils url="mga-logo" imageFormat="png" extraClasses="divider"></image-loader-utils>
      <image-loader-utils url="18" extraClasses="svg-18-2"></image-loader-utils>
      <div class="divider"></div>
      <div class="svg-18-2"></div>
    </div>
  </div>
  <p class="versionText">
    <code>v.{{ VERSION_TEXT }}</code>
  </p>
  <div class="footer-down">
    <ng-container [ngSwitch]="['b3000'] | getProductName">
      <ng-container *ngSwitchCase="'b3000'">
        <div class="partner-name">
          <div class="down-text">{{ 'Footer_Partner_Text' | t }}</div>
          <image-loader-utils url="1860-logo" extraClasses="logo-partner" [shared]="false" imageFormat="png"></image-loader-utils>
          <image-loader-utils url="eintracht_Braunschweig" extraClasses="logo-partner-b3000" [shared]="false" imageFormat="png"></image-loader-utils>
        </div>
      </ng-container>
    </ng-container>
    <div class="more-from">{{ 'more_from_the_game' | t }}</div>
  </div>
</div>
